"use strict";

angular.module("core")
.constant("SUPPORT_ASSISTANT_MINIMIZED_DEFAULT_VALUE", false);



//////////////////
// WEBPACK FOOTER
// ./core/support-assistant/support-assistant.constant.js
// module id = 387
// module chunks = 0